import React from 'react';
import Img from 'gatsby-image';
// @ts-ignore (no types available for 'gatsby-storyblok-image')
import { getFluidGatsbyImage } from 'gatsby-storyblok-image';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';
import { NavigationItemBannerStoryblok } from '../../../_shared/interfaces/storyblok';

import * as StylesHs from './navigation-banner.hs.module.scss';
import * as StylesDr from './navigation-banner.dr.module.scss';
import StoryblokButton from '../hs-button/storyblok-button';

const NavigationBanner = ({
    blok,
    storyblokCommon,
    wide = false,
    navigationId = 'navigation',
}: {
    blok: NavigationItemBannerStoryblok | undefined;
    storyblokCommon: StoryblokCommon;
    wide?: boolean;
    navigationId?: string;
}) => {
    const styles = storyblokCommon.configuration.content.theme === 'dr' ? StylesDr : StylesHs;

    const showImage = (navigationItemBanner: NavigationItemBannerStoryblok): React.ReactFragment => {
        return (
            <div className={styles.navigationBannerImageWrapper}>
                {navigationItemBanner.image?.filename && (
                    <Img
                        className={styles.navigationBannerImage}
                        fluid={{
                            ...getFluidGatsbyImage(
                                wide && navigationItemBanner.image_wide
                                    ? navigationItemBanner.image_wide.filename
                                    : navigationItemBanner.image && navigationItemBanner.image.filename,
                            ),
                            media: '(max-width: 767px)',
                        }}
                        alt={navigationItemBanner.image?.alt ?? ''}
                    />
                )}
            </div>
        );
    };

    return (
        <>
            {blok && (
                <div
                    id={navigationId + '-item-wrapper-' + blok._uid}
                    className={`${styles.navigationBannerWrapper} ${wide ? styles.navigationBannerWide : ''}`}
                >
                    <div id={navigationId + '-item-' + blok._uid} className={styles.navigationBannerGrid}>
                        {showImage(blok)}

                        <div id={navigationId + '-item-' + blok._uid} className={styles.navigationBanner}>
                            <div id={navigationId + '-headline-' + blok._uid} className={styles.navigationBannerHeadline}>
                                {blok.text}
                            </div>

                            {showImage(blok)}

                            <div id={navigationId + '-button-' + blok._uid} className={styles.navigationBannerButtonWrapper}>
                                <StoryblokButton blok={blok.button[0]} storyblokCommon={storyblokCommon} size="small" />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default NavigationBanner;
